// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiDropBoost {
    'booster': ApiProfileMin;
    'boosted_at': number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "booster",
            "baseName": "booster",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "boosted_at",
            "baseName": "boosted_at",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiDropBoost.attributeTypeMap;
    }

    public constructor() {
    }
}

